import React, { lazy, Suspense } from 'react';

const DatepickerLazy = lazy(() => import('./DatepickerComponent'));

export const LazyLoadedDatepicker = props => (
  <Suspense fallback={<></>}>
    <DatepickerLazy {...props} />
  </Suspense>
);
